export default __webpack_public_path__ + "static/UV Signature Class – 1280px-2393a3eba46c14c0380364b84518f038.jpg";